import { render, staticRenderFns } from "./ConfirmArrestsModal.vue?vue&type=template&id=36aa5c58&scoped=true&"
import script from "./ConfirmArrestsModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmArrestsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmArrestsModal.vue?vue&type=style&index=0&id=36aa5c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa5c58",
  null
  
)

export default component.exports